<template>
  <div class="reports-index">
    <h3>Табель рабочего времени</h3>
    <div class="create-new">
      <router-link :to="`/dashboard/reports/create/TABEL`"
                   v-if="isReportEnabledByPlan($store)"
                   class="add-block">
        <el-button type="primary"> + Создать новый табель</el-button>
      </router-link>
    </div>
    <div class="search-filter">
      <el-input placeholder="Поиск по номеру табеля" v-model="search" @input="searchInput" class="input-search">
        <el-button slot="append" icon="el-icon-search" @click="fetchReports"></el-button>
      </el-input>
      <div class="filter-worker">
        <el-form class="type-filter-margin-0">
          <filter-select hide-label placeholder="Пользователь" v-model="userSelect" :options="options"
                         @input="selectUser"/>
        </el-form>
      </div>
      <div class="filter">
        <date-picker
          :editable="false"
          ref="datePicker"
          placeholder="Фильтр по дате"
          v-model="datetimeRange"
          @change="changeDateTime"
          range
        ></date-picker>

      </div>
      <a class="filter-btn" @click="openDialog = true">
        <el-button type="default">Выгрузить отчет</el-button>
      </a>
    </div>
    <div class="reports-ul">
      <router-link
        :to="`/dashboard/reports/create/${report.id}/TABEL`"
        :key="`${report.id}_${key}`"
        class="reports-li" v-for="(report, key) in filterReports"
      >
        <div :class="['header-id']">
          <div style="display: flex; align-items: center">
            <span style="margin-right: 4px">#{{ report.index }}</span>
            <i style="pointer-events: none" class="el-icon-success" v-if="report.approved"></i>
          </div>
          <span>{{ report.date }}</span>
        </div>
        <span>Пользователь: <strong>{{ report.user }}</strong></span>
        <span>Компания: <strong>{{ report.company }}</strong></span>
        <span>Смена: <strong>{{ report.turn }}</strong></span>
        <span>Объект: <strong>{{ report.objectId }}</strong></span>
      </router-link>
    </div>

    <el-dialog
      @close="closeDialog"
      title="Выгрузить отчет"
      :visible.sync="openDialog"
      width="30%"
      v-loading="loaderDownload"
      center
    >
      <el-form v-if="type_select" style="display: flex; flex-direction: column;">
        <div v-if="type_select === 'MAIN'">
          <date-picker
            :clearable="false"
            ref="datePicker"
            placeholder="Фильтр по дате"
            v-model="datetimeRangeDownload"
            range
          ></date-picker>
          <el-checkbox style="margin-top: 10px" v-model="allTime">За все время</el-checkbox>

        </div>
        <div v-else>
          <date-picker
            v-if="type_select === 'TYPE_3'"
            :clearable="false"
            ref="datePicker"
            placeholder="Фильтр по дате"
            v-model="datetimeRangeDownload"
            range
          ></date-picker>
          <date-picker
            v-else
            :clearable="false"
            style="width: 100%; max-width: 240px"
            ref="datePicker"
            placeholder="Фильтр по дате"
            v-model="dateMonth"

            type="month"
          ></date-picker>
          <el-checkbox v-if="type_select === 'TYPE_3'" style="margin-top: 10px" v-model="allTime">За все время
          </el-checkbox>
          <el-checkbox v-if="role === 'admin'" style="margin-top: 10px" v-model="showAll">
            Все работники
          </el-checkbox>
          <el-checkbox style="margin-top: 10px" v-model="allCompany" v-if="role === 'admin'">Все компании</el-checkbox>
          <div v-if="!allCompany">
            <filter-select style="margin-bottom: 2px" label="Компании" multiple :options="companies"
                           v-model="selectCompanies"/>
          </div>
          <template v-if="type_select !== 'MAIN'">
            <div>
              <filter-select style="margin-bottom: 2px" label="Объекты" multiple :options="optionsFilter.objects"
                             v-model="filter.objectsIds"/>
            </div>
            <div>
              <filter-select style="margin-bottom: 2px" label="Виды работ" multiple :options="optionsFilter.workTypes"
                             v-model="filter.workTypesIds"/>
            </div>
            <div>
              <filter-select style="margin-bottom: 2px" label="Смены" multiple :options="optionsFilter.turns"
                             v-model="filter.turns"/>
            </div>
          </template>
        </div>
      </el-form>
      <div v-else>
        <div style="width: 100%; margin-top: 10px;">
          <el-button style="width: 100%" @click="type_select = 'MAIN'">Журнал выхода работников</el-button>
        </div>
        <div style="width: 100%; margin-top: 10px;">
          <el-button style="width: 100%" @click="type_select = 'TYPE_1'">Форма табеля (Т-12)</el-button>
        </div>
        <div style="width: 100%; margin-top: 10px;">
          <el-button style="width: 100%" @click="type_select = 'TYPE_2'">Форма табеля 2</el-button>
        </div>
        <div style="width: 100%; margin-top: 10px;">
          <el-button style="width: 100%" @click="type_select = 'TYPE_3'">Форма табеля 3</el-button>
        </div>
      </div>
      <span slot="footer" class="dialog-footer" v-if="type_select">
        <el-button @click="closeDialog">Закрыть</el-button>
        <a @click="download" target="_blank">
          <el-button type="primary">Выгрузить</el-button>
        </a>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import firebase from 'firebase';
import dayjs from 'dayjs';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import _ from 'lodash';
import FilterSelect from "../../../components/FilterSelect";
import {isReportEnabledByPlan} from "../../../utils/permission";
import ReportModal from "./components/ReportModal";
import TabelProxy from "../../../proxy/TabelProxy";
import {getObjectOptions} from "../../../firestore/objects";
import fileDownload from "js-file-download";
import {downloadURI} from "../../../utils/urlUtils";

export default {
  name: 'Index',
  components: {ReportModal, FilterSelect, DatePicker},
  data() {
    return {
      loaderDownload: false,
      plan: {
        isTurn: true,
        isResource: true,
        isFact: true
      },
      dateMonth: new Date(String(dayjs().utc().format('YYYY-MM'))),
      datetimeRangeDownload: [],
      type_select: null,
      companies: [],
      lockNavigate: false,
      showAll: false,
      openDialog: false,
      allTime: false,
      allCompany: true,
      search: '',
      selectCompanies: null,
      dayTurn: {
        label: 'Весь день',
        value: null,
      },
      role: 'admin',
      userSelect: {
        label: 'Все пользователи',
        value: null
      },
      filter: {
        objectsIds: [],
        workTypesIds: [],
        turns: []
      },
      optionsFilter: {
        objects: [],
        workTypes: [],
        turns: []
      },
      options: [],
      tr: {
        COVID: 'по температуре',
        PROF: 'по численности',
        TECH: 'по технике',
        JOB: 'по работам',
        MATERIALS: 'по материалам',
        MAIN: 'общий отчет',
        WILD_PIPE: 'по сварке трубопроводов',
        TABEL: 'Табель рабочего времени'
      },
      datetimeRange: [
        new Date(String(dayjs().utc().subtract(10, 'days').format('YYYY-MM-DD'))),
        new Date(String(dayjs().utc().format('YYYY-MM-DD'))),
      ],
      reports: [],
    };
  },

  computed: {
    filterReports() {
      return this.reports.filter(({index}) => {
        return !this.search || '' + this.search === '' + index
      })
    }
  },
  async mounted() {
    await this.fetchUsers();
    this.userSelect = this.$route.query.user || null
    if (this.userSelect) {
      this.userSelect = JSON.parse(this.userSelect)
    }

    if (this.$route.query.start) {
      this.datetimeRange = [
        new Date(String(this.$route.query.start)),
        new Date(String(this.$route.query.end)),
      ];
    } else if (this.$store.state.project.disableDate) {
      this.datetimeRange = [
        new Date(String(dayjs().subtract(365 * 10, 'days').format('YYYY-MM-DD'))),
        new Date(String(dayjs().format('YYYY-MM-DD'))),
      ];
    }


    this.optionsFilter.turns = [{
      label: 1,
      value: 1,
    }, {
      label: 2,
      value: 2,
    }, {
      label: 3,
      value: 3,
    }]

    myFirestore
      .collection('projects')
      .doc(this.$store.state.project.id)
      .collection('users')
      .where('uid', '==', authFirestore.currentUser.uid)
      .get().then(async (response) => {
      await response.forEach((sub) => {
        const data = sub.data();
        if (data) {
          this.role = data.role;
          this.loading = false;
        }
      });
      this.fetchReports();
      this.getWorkType();
      this.fetchUsers();
    });
  },

  watch: {
    '$route.query': {
      handler(response) {
        this.fetchReports();
      },
      deep: true,
    },
    type_select() {
      if (this.type_select === 'DAILY' || this.type_select === 'DAILY_PLAN') {
        this.datetimeRangeDownload = [
          new Date(String(dayjs().utc().subtract(1, 'day').format('YYYY-MM-DD'))),
          new Date(String(dayjs().utc().format('YYYY-MM-DD'))),
        ]
      } else {
        this.datetimeRangeDownload = [
          new Date(String(dayjs().utc().subtract(1, 'month').format('YYYY-MM-DD'))),
          new Date(String(dayjs().utc().format('YYYY-MM-DD'))),
        ]
      }
    }
  },

  methods: {
    async getWorkType() {
      const result = []
      const response = await myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('works_type')
        .where('type', 'in', ['job', 'JOB']).get();
      response.forEach((d) => {

        result.push({
          label: d.data().name,
          value: d.id,
          index: d.data().index
        })
      })
      this.optionsFilter.workTypes = result
    },
    async download() {
      if (this.type_select === 'MAIN') {
        this.loaderDownload = true

        try {
          const proxy = new TabelProxy()

          if (this.allTime) {
            await downloadURI(proxy.getTimeSheet(this.$store.state.project.id,
              null,
              null
            ), 'workerExitLog.xlsx', proxy.headers)
          } else {
            await downloadURI(proxy.getTimeSheet(this.$store.state.project.id,
              this.datetimeRangeDownload[0] ? dayjs(this.datetimeRangeDownload[0]).format('YYYY-MM-DD') : null,
              this.datetimeRangeDownload[0] ? dayjs(this.datetimeRangeDownload[1]).format('YYYY-MM-DD') : null
            ), 'workerExitLog.xlsx', proxy.headers)
          }

          // console.log(proxy.headers, 'proxy.headers')
          //
          // if (response) {
          //   if (response.errorCode) {
          //     this.$notify({
          //       offset: 60,
          //       title: 'Упс... ',
          //       message: 'Произошла серверная ошибка, повторите позже',
          //       type: 'error',
          //     });
          //   }
          // }
        } catch (e) {
          this.$notify({
            offset: 60,
            title: 'Упс... ',
            message: 'Произошла серверная ошибка, повторите позже',
            type: 'error',
          });
        }

        this.closeDialog()
        this.loaderDownload = false

      } else {
        this.loaderDownload = true

        try {
          const proxy = new TabelProxy()

          if (this.type_select === 'TYPE_1') {
            await downloadURI(proxy.getFormT12type1(this.$store.state.project.id,
              dayjs(this.dateMonth).format('YYYY-MM'),
              this.allCompany ? [] : this.selectCompanies,
              this.showAll,
              this.filter
            ), 'formT12.xlsx', proxy.headers)
          }

          if (this.type_select === 'TYPE_2') {
            await downloadURI(proxy.getFormT12type2(this.$store.state.project.id,
              dayjs(this.dateMonth).format('YYYY-MM'),
              this.allCompany ? [] : this.selectCompanies,
              this.showAll,
              this.filter
            ), 'formV2.xlsx', proxy.headers)
          }

          if (this.type_select === 'TYPE_3') {

            if (this.allTime) {
              await downloadURI(proxy.getFormT12type3(this.$store.state.project.id,
                null,
                null,
                this.allCompany ? [] : this.selectCompanies,
                this.showAll,
                this.filter
              ), 'formV3.xlsx', proxy.headers)
            } else {
              await downloadURI(proxy.getFormT12type3(this.$store.state.project.id,
                this.datetimeRangeDownload[0] ? dayjs(this.datetimeRangeDownload[0]).format('YYYY-MM-DD') : null,
                this.datetimeRangeDownload[0] ? dayjs(this.datetimeRangeDownload[1]).format('YYYY-MM-DD') : null,
                this.allCompany ? [] : this.selectCompanies,
                this.showAll,
                this.filter
              ), 'formV3.xlsx', proxy.headers)
            }
          }

          // console.log(proxy.headers, 'proxy.headers')
          //
          // if (response) {
          //   if (response.errorCode) {
          //     this.$notify({
          //       offset: 60,
          //       title: 'Упс... ',
          //       message: 'Произошла серверная ошибка, повторите позже',
          //       type: 'error',
          //     });
          //   }
          // }
        } catch (e) {
          this.$notify({
            offset: 60,
            title: 'Упс... ',
            message: 'Произошла серверная ошибка, повторите позже',
            type: 'error',
          });
        }

        this.closeDialog()
        this.loaderDownload = false

      }
    },
    lockHide() {
      setTimeout(() => {
        this.lockNavigate = false
      }, 800)
    },
    toReport(report) {
      if (this.lockNavigate) {
        return
      }
      this.$router.push(`/dashboard/reports/create/${report.id}/${report.type}`);
    },
    isReportEnabledByPlan,
    searchInput: _.debounce(function (el, binding) {
      this.fetchReports();
    }, 500),
    closeDialog() {
      setTimeout(() => {
        this.openDialog = false;
        this.type_select = null;
        this.downloadWithPrice = false;
        if (this.role === 'admin') {
          this.selectCompanies = null;
        }
        this.allTime = false
        this.isProfession = false;
        this.allCompany = true;
        this.downloadForAll = false;
        this.dayTurn = {
          label: 'Весь день',
          value: null,
        }
      }, 10);
    },
    selectUser() {
      let query = {
        ...this.$route.query,
      };
      if (!this.userSelect || !this.userSelect.value) {
        delete query.user;
      } else {
        query = {
          ...this.$route.query,
          user: JSON.stringify(this.userSelect),
        };
      }
      this.$router.push({
        path: this.$route.path,
        query: {
          ...query,
        },
      });
    },
    fetchUsers() {
      this.loader = true;
      return new Promise((resolve, reject) => {
        myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('users')
          .get()
          .then(async (data) => {
            const result = [{label: 'Все пользователи', value: null, isCompany: 1}];
            await data.forEach((subDoc) => {
              let _data = subDoc.data();
              result.push({
                label: _data.name || _data.email,
                value: _data.uid,
                isCompany: _data.isCompany ? 1 : 0,
                _data: _data
              });
            });

            this.options = _.orderBy(_.unionBy(result, 'label'), ['isCompany'], ['desc']);
            resolve();

          }).finally(() => {
          resolve();
          this.loading = false;
        }).catch((e) => {
          this.loading = false;
        });
      })
    },
    changeDateTime() {
      if (this.datetimeRange[0] && this.datetimeRange[1]) {
        this.$router.push({
          path: this.$route.path,
          query: {
            ...this.$route.query,
            start: dayjs(this.datetimeRange[0]).format('YYYY-MM-DD'),
            end: dayjs(this.datetimeRange[1]).format('YYYY-MM-DD'),
          },
        });
      } else {
        this.$router.push({
          path: this.$route.path,
          query: {
            ...this.$route.query,
            start: dayjs().subtract(10, 'days').format('YYYY-MM-DD'),
            end: dayjs().add(1, 'days').format('YYYY-MM-DD'),
          },
        });
      }
    },
    sendReport() {
      const proxy = firebase.functions().httpsCallable(`onGenerateLogCommonJobs/${this.$store.state.project.id}`);
      proxy().then(() => {
        this.$notify({
          offset: 60,

          title: 'Успешно!',
          message: 'Отчет отправлен вам на почту',
          type: 'success',
        });
      }).catch(() => {
        this.$notify({
          offset: 60,

          title: 'Ошибка',
          message: 'Произошла ошибка, попробуйте позже',
          type: 'error',
        });
      });
    },
    navigate(report) {
      this.$router.push(
        `/dashboard/reports/edit/${report.id}/${this.$route.params.type}`,
      );
    },
    async fetchReports() {
      const proxy = new TabelProxy()
      const filter = {}

      if (this.$route.query.start && this.$route.query.end) {
        filter.dateTo = dayjs(this.$route.query.end).format('YYYY-MM-DD')
        filter.dateFrom = dayjs(this.$route.query.start).format('YYYY-MM-DD')
      } else {
        filter.dateTo = dayjs(this.datetimeRange[1]).format('YYYY-MM-DD')
        filter.dateFrom = dayjs(this.datetimeRange[0]).format('YYYY-MM-DD')
      }

      const response = await proxy.getTables(this.$store.state.project.id, filter)
      const objects = await getObjectOptions(this.$store.state.project.id, undefined, undefined, true);

      this.optionsFilter.objects = [...objects];
      let result = []
      myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('users')
        .get()
        .then((data) => {

          data.forEach((subDoc) => {
            let _data = subDoc.data();

            result.push({..._data, id: subDoc.id});
          });
        }).finally(() => {
        const companies = result.filter((r) => r.isCompany);

        this.companies = companies.map(({id, name}) => {
          return {
            label: name,
            value: id
          }
        })

        const user = this.options.find(({value}) => value === authFirestore.currentUser.uid)

        if (this.role !== 'admin') {

          if (user) {
            const company = this.companies.find(({label}) => user._data.company === label)
            if (company) {
              this.selectCompanies = [company]
              this.selectCompanies = [...this.selectCompanies]
            }
          }
        }

        const reports = []
        response.data.forEach((r) => {
          const company = companies.find((t) => t.id === r.companyId)
          const user = result.find((t) => t.id === r.timesheet.companyId || t.uid === r.timesheet.companyId)


          let userQ = this.$route.query.user;

          if (userQ) {
            userQ = JSON.parse(userQ);
            const companyQ = this.options.find((d) => d.value === userQ.value && d.isCompany);

            if (!(user.uid === userQ.value || user.id === userQ.value ||
              ((companyQ && company && company.uid === companyQ.value) || companyQ && company && company.id === companyQ.value))) {
              return
            }
          }

          const objectName = objects.find((o) => o.value === r.objectId)

          reports.push({
            date: dayjs(r.timesheetDate).format('DD/MM/YYYY'),
            turn: r.timesheet.turn.value,
            approved: r.approved,
            company: company && company.name,
            objectId: objectName ? objectName.label : '-',
            user: user && (user.name || user.email),
            index: r.timesheetNumber,
            id: r._id
          })
        })

        this.reports = reports
      })
    },
  }
}
;
</script>

<style scoped lang="scss">
.reports-index {
  margin: 0 auto;
  max-width: 1024px;
  padding-top: 20px;
}

.reports-ul {
  display: flex;
  flex-direction: column;
  margin-top: 20px;
}

.input-search {
  margin-top: 10px;
}

.reports-li {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-bottom: 1px solid rgba(0, 0, 0, 0.18);
  padding: 10px 14px;
  text-decoration: none;
  color: #000;

  span {
    text-align: left;
  }

  &--child {
    width: 100%;
    display: flex;
    text-decoration: none;
    cursor: pointer;
    flex: 1;
    flex-direction: column;
    align-items: flex-start;

  }

  .header-id {
    display: flex;
    justify-content: space-between;
    margin-bottom: 6px;
    width: 100%;
  }

  span {
    font-size: 14px;
    color: #2c3e50;
  }

  span:first-child {
    margin-right: 20px;
  }


  span {
    margin-right: 5px;
  }

  &:hover {
    background: #f5f5f5;
  }
}

> > > .el-date-editor--daterange.el-input__inner {
  width: 100%;
  margin-top: 10px;
}

.add-block {
  button {
    width: 100%;
    margin-top: 10px;
  }
}

.search-filter {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-width: 260px;

  .input-search {
    margin-right: 10px;
    min-width: 260px;
  }

  .filter-btn {
    margin-top: 10px;
    margin-left: 10px;
  }
}

.create-new {
  display: flex;
  justify-content: flex-start;
  flex: 1;
}

.jobs-list {
  display: flex;
  flex-direction: column;
}

@media screen and (max-width: 764px) {
  .search-filter {
    flex-direction: column;

    .filter {
      width: 100%;
    }
  }

  .filter-btn {
    width: 100%;
    margin-left: 0 !important;

    button {
      width: 100%;
    }
  }
  .reports-index {
    padding: 0 10px;
  }

  .search-filter .input-search {
    margin-right: 0;
  }

  .filter-worker {
    width: 100%;

    .el-form-item {
      margin-bottom: 0;
    }

    .el-select {
      width: 100%;
    }
  }
}

.create-new {
  display: flex;
  justify-content: space-between;
}

.filter {
  min-width: 260px;
}

.filter-worker {
  min-width: 200px;
  margin-top: 10px;
  margin-right: 5px;
}

> > > .mx-datepicker-range {
  width: 100%;
  margin-top: 10px;

  .mx-input {
    border: 1px solid #DCDFE6;
    height: 40px;
  }
}

.disabled {
  opacity: 0.7;
}

.mb-1 {
  margin-bottom: 10px;
}

.el-icon-success {
  color: #2ecc71;
}
</style>
<style lang="scss">
.search-filter {
  .filter-worker {
    width: 100%;

    .el-form-item {
      margin-bottom: 0 !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Reports/TypeTabel.vue